import { render, staticRenderFns } from "./CantidadesGrupo.vue?vue&type=template&id=45a983c2&"
import script from "./CantidadesGrupo.vue?vue&type=script&lang=js&"
export * from "./CantidadesGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports